import {api} from '../../utils/api'

export default {

    /**
     * Upload file
     * @param commit
     * @param node_id
     * @param type
     * @param file
     * @param sub_id
     * @param task_id
     * @returns {*|Promise|Promise<any>}
     */
    upload({commit}, {node_id, type, file, sub_id}) {

        // prepare form data
        let formData = new FormData();
        formData.append('file_data', file);
        formData.append('node_id', node_id);
        formData.append('type', type);
        if(sub_id) formData.append('sub_id', sub_id);
        console.log(file);

        // Api call
        return api.call(commit, 'post', '//'+process.env.VUE_APP_CONTENT_API_URL + '/api/content/upload', formData, "SET_CONTENT", null, 'multipart/form-data');
    },

    /**
     * Create content
     * @param commit
     * @param node_id
     * @param type
     * @param data
     * @returns {*|Promise|Promise<any>}
     */
    create({commit}, {node_id, type, data}) {
        // Api call
        return api.call(commit, 'post', '//'+process.env.VUE_APP_CONTENT_API_URL + `/api/content/${node_id}/${type}`, {data}, "SET_CONTENT");
    },


    /**
     * Update content
     * @param commit
     * @param node_id
     * @param type
     * @param data
     * @returns {*|Promise|Promise<any>}
     */
    update({commit}, {content_id, data}) {
        // Api call
        return api.call(commit, 'patch', '//'+process.env.VUE_APP_CONTENT_API_URL + `/api/content/${content_id}`, {data}, "SET_CONTENT");
    },

    /**
     * get node content
     * @param commit
     * @param node_id
     * @param type
     * @returns {*|Promise|Promise<any>}
     */
    loadNodeContent({commit}, {node_id, type}) {
        // Api call
        return api.call(commit, 'get', '//'+process.env.VUE_APP_CONTENT_API_URL + `/api/content/list/${node_id}/${type}`, false, "SET_CONTENT");
    },

    /**
     * Remove content
     * @param commit
     * @param id
     * @param payload
     * @returns {Promise<any>}
     */
    remove({ commit }, id) {

        // Call register
        return api.call(commit, 'delete', '//'+process.env.VUE_APP_CONTENT_API_URL + `/api/content/${id}`, false, 'DELETE_CONTENT');
    },

    /**
     * Load content details
     * @param commit
     * @param id
     * @param payload
     * @returns {Promise<any>}
     */
    loadDetails({ commit }, id) {

        // Call register
        return api.call(commit, 'get', '//'+process.env.VUE_APP_CONTENT_API_URL + `/api/content/${id}/details`, false, 'SET_CONTENT');
    },

  /**
     * Load content data
     * @param commit
     * @param id
     * @param payload
     * @returns {Promise<any>}
     */
    loadContent({ commit }, id) {

        // Call register
        return api.call(commit, 'get', '//'+process.env.VUE_APP_CONTENT_API_URL + `/api/content/${id}/data`, false, 'SET_CONTENT');
    },

    /**
     * Get resource preview
     * @returns {(function(*))|*}
     * @param state
     */
    getPreview: state => (id) => {
        return state ? '//' + process.env.VUE_APP_CONTENT_API_URL + `/api/content/${id}/preview` : false;
    },

    /**
     * Authorize on content service
     */
    auth() {
        // Call register
        return api.call(false, 'get', '//'+process.env.VUE_APP_CONTENT_API_URL + `/api/content/auth`);
    }
}
